



















































import { Component, Vue, Mixins } from 'vue-property-decorator'
import Visualization from '../../mixins/Visualization.vue'

@Component
export default class Range extends Mixins(Visualization) {
  /**
   * Active.
   */
  public active: boolean[] | boolean[][] = []
}
